import React, { useRef, KeyboardEvent } from "react";
import { useHistory } from "react-router-dom";

// Interface for individual tab items
interface ITabItem {
  label: string;
  name: string;
  icon?: JSX.Element; // Optional icon
  visible: boolean;
  index: number;
}

// Interface for the tabs component props
interface IAccessibleVerticalTabs {
  menuItems: ITabItem[];
  handleTabClick: (name: string) => void;
  isMediumScreen?: boolean;
  url: string;
}

export const AccessibleVerticalTabs = ({ menuItems, handleTabClick, isMediumScreen, url }: IAccessibleVerticalTabs) => {
  const history = useHistory();
  const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>, name: string) => {
    const currentIndex = menuItems.findIndex((item) => item.name.toLowerCase() === name.toLowerCase());

    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      let nextIndex = currentIndex;

      if (event.key === "ArrowDown") {
        do {
          nextIndex = (nextIndex + 1) % menuItems.length;
        } while (!menuItems[nextIndex].visible);
      } else if (event.key === "ArrowUp") {
        do {
          nextIndex = (nextIndex - 1 + menuItems.length) % menuItems.length;
        } while (!menuItems[nextIndex].visible);
      }

      const route = menuItems[nextIndex].name;
      history.push(`/${url}/${route}`);
      tabsRef.current[nextIndex]?.focus();
    }
  };

  return (
    <div role='tablist' className={`tab-list vertical`} aria-label='Application Types' aria-orientation={"vertical"}>
      {menuItems.map((item) => {
        const activeItem = location.pathname.includes(item.name);
        return (
          item.visible && (
            <button
              key={item.name}
              role='tab'
              aria-selected={activeItem ? "true" : "false"}
              tabIndex={activeItem ? 0 : -1}
              onClick={() => handleTabClick(item.name)}
              onKeyDown={(e) => handleKeyDown(e, item.name)}
              className={`${activeItem ? "active" : ""} ${activeItem ? "tw-font-bold" : "tw-font-normal"}`}
              style={{ display: "flex", alignItems: "center", gap: 16 }}
              ref={(el) => (tabsRef.current[item.index] = el)}
            >
              {!isMediumScreen && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    color: "#7a7a7a",
                  }}
                >
                  {item.icon}
                </div>
              )}
              {item.label}
            </button>
          )
        );
      })}
    </div>
  );
};
